import { ODataMap, ODataObjectMap } from '../types';
import { generateGraphQlQuery, generateGraphQlSchema } from '../utils';

const RegionMap = {
  code: {
    bcKey: 'Code',
    type: 'string',
    required: false,
  },
  description: {
    bcKey: 'Description',
    type: 'string',
    required: false,
  },
  company: {
    bcKey: 'Company',
    type: 'string',
    required: false,
  },
  comment: {
    bcKey: 'Comment',
    type: 'boolean',
    required: false,
  },
} as const satisfies ODataMap;

type Region = ODataObjectMap<typeof RegionMap>;

const RegionSchema = generateGraphQlSchema('Region', RegionMap);
const RegionQuery = generateGraphQlQuery('Region', RegionMap);

export { RegionSchema, type Region, RegionQuery, RegionMap };
